import { ManagerStore } from '../../stores/manager.store';
import {
    WidgetDataValues,
    ReportModuleGroup,
    ReportStatus,
    WidgetData,
    WidgetSubmitDataValues,
    WidgetType,
    WidgetDataNumericProperties,
    WidgetDataDatetimeProperties
} from '../../models/report';
import { Marker } from '../../models/marker';
import dayjs from 'dayjs';

export class ReportsTabUtilities {
    constructor(
        public readonly managerStore: ManagerStore
    ) { }

    submitReport = (
        widgetDataValues: WidgetDataValues,
        selectedMarker: Marker | undefined,
        moduleGroup: ReportModuleGroup | undefined
    ): Promise<void> => {
        const { managerStore } = this;
        const {
            reportModules,
            // userModuleGroups
        } = managerStore;

        if (!selectedMarker || !moduleGroup) {
            return Promise.reject('Submit report call was invoked with invalid parameters.');
        }

        const reportModuleGroupId = moduleGroup.id.toLocaleLowerCase();
        // const reportModuleGroup: ReportModuleGroup | undefined =
        //     userModuleGroups.find((currentModuleGroup) => {
        //         return currentModuleGroup.id.toLocaleLowerCase().indexOf(reportModuleGroupId) >= 0;
        //     });

        // if (!reportModuleGroup) {
        //     return Promise.reject('User is not authorized to submit the report.');
        // }

        // Remove the blank fields from the payload
        const widgetValues: WidgetDataValues =
            Object.keys(widgetDataValues)
                .filter((key: string) => {
                    return !!widgetDataValues[key];
                })
                .reduce((newObject: WidgetDataValues, key: string) => {
                    newObject[key] = widgetDataValues[key];
                    return newObject;
                }, {} as WidgetDataValues);

        const URGENT_VALUE_NAME = 'toggle';
        const statusUnresolved = ReportStatus.Unresolved;
        const status = 
            (reportModuleGroupId === 'maintenance') ?// TO-DO: This should be moduleID
                ((widgetValues[URGENT_VALUE_NAME]) &&
                ((widgetValues[URGENT_VALUE_NAME] as string).toLocaleLowerCase() === 'yes')) ? 
                    ReportStatus.Urgent :
                    statusUnresolved
                : statusUnresolved;

        const currentReportModule = reportModules[0];
        const { reportContent: { widgets }} = currentReportModule;
        const widgetSubmitValues: WidgetSubmitDataValues = {};
        
        widgets.map((widget: WidgetData) => {
            if (widget.properties?.widgetId === undefined) return;

            const widgetId = `${widget.properties.widgetId}`;
            const widgetType = widget.type;
            // eslint-disable-next-line no-prototype-builtins
            if (!widgetValues.hasOwnProperty(widgetId)) return;

            // Set the value for the widget in the submit values object
            widgetSubmitValues[widgetId] = widgetValues[widgetId];

            // Check if widget is NumericField and decimal to use value and fraction for the widget
            if (widgetType === WidgetType.NumericField) {
                const { type } = widget.properties as WidgetDataNumericProperties;
                if (type === 'decimal') {
                    const stringValue = `${widgetValues[widgetId]}`;
                    const numericValue = parseFloat(stringValue.replace('.', ''));
                    const fraction = stringValue.includes('.') ? stringValue.split('.')[1].length : 0;
                    widgetSubmitValues[widgetId] = {
                        value: numericValue,
                        fraction: Math.pow(10, fraction)
                    };
                }
            }

            if (widgetType === WidgetType.DatetimeField) {
                const { type } = widget.properties as WidgetDataDatetimeProperties;
                if (type === 'dateonly') {
                    widgetValues[widgetId] = `${dayjs(widgetValues[widgetId]).format('LL')}`;
                } else if (type === 'datetime') {
                    widgetValues[widgetId] = `${dayjs(widgetValues[widgetId]).format('LLL')}`;
                }
            }
        });

        const summary = WidgetData.parseTagsFromString(currentReportModule.summary, widgetValues);

        return managerStore.submitReport(
            selectedMarker.id,
            currentReportModule.id,
            moduleGroup.id,
            widgetSubmitValues,
            status,
            summary
        );
    };
}
